export default "__VITE_ASSET__a4650d01__"